import {
  MetaMasivaDireccion,
  MetaMasivaFiltro,
  MetaMasivaRequest,
  MetaMasivaResultado,
  MetaMasivaSearchResult
} from '../../model/meta-masiva/meta-masiva';

/**
 * Puerto Abstracto: MetaMasivaRepository
 *
 * Contrato de Administración › Maestros › Metas (HU1290096).
 *
 * Legacy Reference:
 * - ListarMetasAnioActivity / NuevaMetaMasivaActivity / AdminMetasHandler
 * - MetaMasivaFacade, EmpleadoMetaFacade.actualizarMetasMasivas
 * - Tabla TPSC_METAS_MASIVAS
 */
export abstract class MetaMasivaRepository {
  /**
   * Lista las metas activas de una oficina y un año con paginación por cursor.
   * `size` es obligatorio y está acotado a 1..100.
   */
  abstract listar(
    filtro: MetaMasivaFiltro,
    size: number,
    cursor?: string | null,
    direction?: MetaMasivaDireccion
  ): Promise<MetaMasivaSearchResult>;

  /** Nueva meta masiva (todo o nada). Ejecuta SP_PSC_ASIG_METAS_MASIVAS una vez. */
  abstract crear(request: MetaMasivaRequest): Promise<MetaMasivaResultado>;

  /** Modifica solo la Meta Mes de una fila. Ejecuta SP_ACTUALIZAR_METAS_MASIV. */
  abstract modificar(
    nmconsecutivo: number,
    metaMes: number
  ): Promise<MetaMasivaResultado>;
}
